// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2dnZO","header":"MergedInvoice_header__LlMhW"};